import {
  genericCreate,
  genericFind,
  genericGet,
  genericRemove,
} from '@/services/common';
import { UUID } from '@/types';
import * as queries from './queries';
import { UpdateLinesheet } from '@/features/linesheet/types';

const USER_LINESHEET_LIMIT = 5;

const create = genericCreate('linesheet');

const find = genericFind('linesheet');

const get = genericGet('linesheet');

const remove = genericRemove('linesheet');

const removeProductsById = (
  ids: string[] = [],
) => (
  queries
    .removeProductsById({ ids })
    .then((response: any) => {
      if (ids.length && !response.delete_linesheet_product.affected_rows) {
        throw {
          code: 'PRODUCTS_NOT_REMOVED',
        };
      }
      return response;
    })
);

const update = (
  linesheetId: UUID,
  linesheet: UpdateLinesheet,
) => (
  queries.update({
    linesheet: {
      ...linesheet,
      id: linesheetId,
      products: {
        data: (linesheet.products || []).map((product, index) => ({
          ...product,
          index,
        })),
        on_conflict: {
          constraint: 'linesheet_product_pkey',
          update_columns: [
            'name',
            'price_retail',
            'price_wholesale',
            'product_id',
            'properties',
            'index',
          ],
        },
      },
    },
  }).then(response => {
    const linesheetResponse = response.table.returning;
    if (!linesheetResponse.length) {
      throw {
        code: 'LINESHEET_NOT_UPDATED',
      };
    }
    return linesheetResponse[0];
  })
);

export default {
  USER_LINESHEET_LIMIT,

  create,
  find,
  get,
  remove,
  removeProductsById,
  update,
};
